"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _services = require("../../services");
var _utils = require("../../utils/utils");
var _constants = require("../../utils/constants");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const PaymentOption = _ref => {
  let {
    price
  } = _ref;
  const {
    type,
    value,
    recurringPriceTerm,
    upfrontPriceTerm
  } = price;
  const isRecurring = type === _constants.PRICE_TYPES.RECURRING;
  const priceTypeLabel = isRecurring ? _services.locale.localeString(`RelationshipOffer.Per.${recurringPriceTerm ? (0, _utils.capitalize)(recurringPriceTerm) : 'Month'}`) : _services.locale.localeString(`RelationshipOffer.Per.${upfrontPriceTerm ? upfrontPriceTerm.units : 'Upfront'}`);
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
    key: type
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      right: 1
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    size: 1,
    weight: 4
  }, _services.locale.formatPrice(value))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      ...(isRecurring && {
        right: 2
      })
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    size: 1
  }, priceTypeLabel)));
};
var _default = PaymentOption;
exports.default = _default;